import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIx20011ListStatus: 'idle',
    loadIx20011ListError: undefined as any,
    loadIx20011ListLastArgs: undefined as any,
    loadIx20011Status: 'idle',
    loadIx20011Error: undefined as any,
    saveIx20011Status: 'idle',
    saveIx20011Error: undefined as any,
    deleteIx20011Status: 'idle',
    deleteIx20011Error: undefined as any,

    ix20011List: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx20011List = createAsyncThunk('ix20011Slice/loadIx20011List', async ({ gridFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix20011Slice.loadIx20011ListLastArgs
    if (_.isEqual(lastArgs, { gridFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_getzlgtoleranzen/?SOBJBEREICH=${gridFilters.values.SOBJBEREICHFILTER}&SPERSONBEREICH=${gridFilters.values.SPERSONBEREICHFILTER}&SDATVON=${gridFilters.values.SDATVONFILTER}&SDATBIS=${gridFilters.values.SDATBISFILTER}&SWDAT=${gridFilters.values.SWDATFILTER}&SKKLRANGE=${gridFilters.values.SKKLRANGEFILTER}&DVONSALDO=${gridFilters.values.DVONSALDOFILTER}&DBISSALDO=${gridFilters.values.DBISSALDOFILTER}&DVONTLGTOLERANZ=${gridFilters.values.DVONTLGTOLERANZFILTER}&DBISTLGTOLERANZ=${gridFilters.values.DBISTLGTOLERANZFILTER}&NSICHTVARIANTE=${gridFilters.values.NSICHTVARIANTEFILTER}&NERWEITERTESALDOANZEIGE=${gridFilters.values.NERWEITERTESALDOANZEIGEFILTER}`, undefined)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx20011ListStatus } = getState().ix20011Slice
        return loadIx20011ListStatus !== 'pending'
    }
})

export const loadIx20011 = createAsyncThunk('ix20011Slice/loadIx20011', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ix20011/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx20011Status } = getState().ix20011Slice
        return loadIx20011Status !== 'pending'
    }
})

export const saveIx20011 = createAsyncThunk('ix20011Slice/saveIx20011', async ({ ix20011 }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ix20011?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ix20011/${ ix20011?.HDR_ID }/`,
            prepareData(ix20011),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ix20011/`,
            prepareData(ix20011),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIx20011Status } = getState().ix20011Slice
        return saveIx20011Status !== 'pending'
    }
})

export const deleteIx20011 = createAsyncThunk('ix20011Slice/deleteIx20011', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ix20011/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIx20011Status } = getState().ix20011Slice
        return deleteIx20011Status !== 'pending'
    }
})

const Ix20011Slice = createSlice({
    name: 'ix20011Slice',
    initialState,
    reducers: {
        resetloadIx20011ListError: (state) => {
            state.loadIx20011ListError = undefined
        },
        resetloadIx20011: (state) => {
            state.formItem = undefined
            state.loadIx20011Error = undefined
        },
        resetloadIx20011Error: (state) => {
            state.loadIx20011Error = undefined
        },
        resetsaveIx20011: (state) => {
            state.formItem = undefined
            state.saveIx20011Error = undefined
        },
        resetsaveIx20011Error: (state) => {
            state.saveIx20011Error = undefined
        },
        resetdeleteIx20011Error: (state) => {
            state.deleteIx20011Error = undefined
        },
        removeFromIx20011ListById: (state, action) => {
            state.ix20011List = state.ix20011List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIx20011ListByIds: (state, action) => {
            state.ix20011List = state.ix20011List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix20011List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx20011ListStatus = 'preloaded'
            state.loadIx20011ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix20011List = []
            state.loadIx20011ListStatus = 'idle'
            state.loadIx20011ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx20011List.pending, (state) => {
            state.loadIx20011ListStatus = 'pending'
            state.loadIx20011ListError = undefined
        })
        builder.addCase(loadIx20011List.fulfilled, (state, action) => {
            state.loadIx20011ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx20011ListLastArgs = action.payload.args

            {
                state.ix20011List = action.payload.data

            }
        })
        builder.addCase(loadIx20011List.rejected, (state, action) => {
            state.loadIx20011ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx20011ListError = action.error.message
            } else {
                state.loadIx20011ListError = action.payload
            }
        })

        builder.addCase(loadIx20011.pending, (state) => {
            state.loadIx20011Status = 'pending'
            state.loadIx20011Error = undefined
        })
        builder.addCase(loadIx20011.fulfilled, (state, action) => {
            state.loadIx20011Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix20011List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix20011List.push(newItem) }
                else { state.ix20011List[i] = { ...state.ix20011List[i], ...newItem } }
            }
        })
        builder.addCase(loadIx20011.rejected, (state, action) => {
            state.loadIx20011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx20011Error = action.error.message
            } else {
                state.loadIx20011Error = action.payload
            }
        })

        builder.addCase(saveIx20011.pending, (state) => {
            state.saveIx20011Status = 'pending'
            state.saveIx20011Error = undefined
        })
        builder.addCase(saveIx20011.fulfilled, (state, action) => {
            state.saveIx20011Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix20011List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix20011List.push(newItem) }
                else { state.ix20011List[i] = { ...state.ix20011List[i], ...newItem } }
            }
        })
        builder.addCase(saveIx20011.rejected, (state, action) => {
            state.saveIx20011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIx20011Error = action.error.message
            } else {
                state.saveIx20011Error = action.payload
            }
        })

        builder.addCase(deleteIx20011.pending, (state) => {
            state.deleteIx20011Status = 'pending'
            state.deleteIx20011Error = undefined
        })
        builder.addCase(deleteIx20011.fulfilled, (state, action) => {
            state.deleteIx20011Status = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ix20011List = state.ix20011List.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ix20011List = state.ix20011List.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIx20011.rejected, (state, action) => {
            state.deleteIx20011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIx20011Error = action.error.message
            } else {
                state.deleteIx20011Error = action.payload
            }
        })

    }
})

export const {
    resetloadIx20011ListError,
    resetloadIx20011,
    resetloadIx20011Error,
    resetsaveIx20011,
    resetsaveIx20011Error,
    resetdeleteIx20011Error,
    removeFromIx20011ListById,
    removeFromIx20011ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix20011Slice.actions
export default Ix20011Slice.reducer
